import { render } from "./BlMailWindow.vue?vue&type=template&id=1b66f88e&scoped=true"
import script from "./BlMailWindow.vue?vue&type=script&lang=js"
export * from "./BlMailWindow.vue?vue&type=script&lang=js"

import "./BlMailWindow.vue?vue&type=style&index=0&id=1b66f88e&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b66f88e"]])

export default __exports__